// Títulos legibles para el Excel Personalizado de nómina (detalle de la nómina y página principal
// de Cálculo de Nóminas). Las llaves son las columnas de `nominas-plazas-vista-optimized`; las que
// no aparecen aquí se titulan automáticamente a partir de su nombre técnico.
const TITULOS_COLUMNAS_NOMINA = {
  importe_imss_sbc: 'Salario Base de Cotización (SBC)',
  // Domicilio congelado al calcular la nómina (personal vigente o, si no hay, fiscal)
  domicilio_tipo: 'Domicilio · Tipo de Dirección',
  domicilio_calle: 'Domicilio · Calle',
  domicilio_numero_exterior: 'Domicilio · Número Exterior',
  domicilio_numero_interior: 'Domicilio · Número Interior',
  domicilio_colonia: 'Domicilio · Colonia',
  domicilio_codigo_postal: 'Domicilio · Código Postal',
  domicilio_municipio: 'Domicilio · Municipio',
  domicilio_estado: 'Domicilio · Estado',
  domicilio_entre_calles: 'Domicilio · Entre Calles',
  domicilio_referencia: 'Domicilio · Referencia',
  domicilio_origen: 'Domicilio · Origen del Dato',
};

export default TITULOS_COLUMNAS_NOMINA;
